<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Modelo Veículo'"
      :titulo="'modelo'"
    />

    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-journal-text fs-5 icon-text-form"></i>
            <span class="txt-title-form">Cadastrar Modelo</span>
          </div>
        </div>
        <form @submit.prevent="onSubmit" id="form">
          <div class="row g-2 p-2">
            <div class="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-8">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="descricao"
                  required
                  autocomplete="off"
                />
                <label>Descrição</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="codigo"
                  required
                />
                <label>Código</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="edicao"
                />
                <label>Edição</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="cilindro"
                />
                <label>Cilindro</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="potencia"
                />
                <label>Potência</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="precoForcado"
                />
                <label>Preço Forçado</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="custoMarcacao"
                  @input="custoMarcacao = formatarValor(custoMarcacao)"
                />
                <label>Custo Marcação</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="precoVenda"
                  @input="precoVenda = formatarValor(precoVenda)"
                />
                <label>Preço Venda</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="anoFabricacao"
                  required
                  autocomplete="off"
                />
                <label>Ano Fabricação</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  type="text"
                  class="form-control txt-form-input"
                  v-model="anoModelo"
                  required
                  autocomplete="off"
                />
                <label>Ano Modelo</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="vendaFutura"
                  required
                >
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
                <label>Venda Futura</label>
              </div>
            </div>
            <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="venda_fei"
                required
              >
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </select>
              <label>Venda F&I</label>
            </div>
          </div> -->
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="status"
                  required
                >
                  <option value="0">Desabilitado</option>
                  <option value="1">Habilitado</option>
                </select>
                <label>Status</label>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  v-model="familiaSelecionada"
                  class="form-control txt-form-input"
                  list="datalistFamilia"
                  id="familia"
                  autocomplete="off"
                  required
                />

                <label>Família</label>
                <datalist id="datalistFamilia">
                  <option
                    v-for="familia in familias"
                    :data-id="familia.id"
                    :value="familia.descricao"
                    :key="familia.id"
                  ></option>
                </datalist>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <input
                  v-model="combustivelSelecionado"
                  class="form-control txt-form-input"
                  list="datalistCombustivel"
                  id="combustivel"
                  autocomplete="off"
                  required
                />

                <label>Combustível</label>
                <datalist id="datalistCombustivel">
                  <option
                    v-for="comb in combustiveis"
                    :data-id="comb.id"
                    :value="comb.descricao"
                    :key="comb.id"
                  ></option>
                </datalist>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="tipo_empresa"
                  required
                >
                  <option value="1">Quatro Rodas</option>
                  <option value="2">Duas Rodas</option>
                </select>
                <label>Tipo Empresa</label>
              </div>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                type="submit"
                class="btn round-btn d-flex align-items-center justify-content-center"
              >
                <i class="bi bi-plus-circle" title="Inserir"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                type="submit"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
              >
                <span>Cadastrar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                type="submit"
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
              >
                <span>Cadastrar</span>
              </button>
            </div>
          </div>
        </form>
        <div v-if="abrir_modal">
          <Message :msg="msg" v-show="msg" />
        </div>
      </div>
    </div>
    <!--Bloco do Filtro-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-funnel fs-5 icon-text-form"></i>
            <span class="txt-title-form">Filtro</span>
          </div>
        </div>
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="searchTitle"
              />
              <label>Descrição</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <div class="form-floating txt-form-label">
              <input
                v-model="searchFamiliaSelecionada"
                class="form-control txt-form-input"
                list="datalistFamilia"
                id="familia"
                autocomplete="off"
                required
              />

              <label>Família</label>
              <datalist id="datalistFamilia">
                <option
                  v-for="familia in familias"
                  :data-id="familia.id"
                  :value="familia.descricao"
                  :key="familia.id"
                ></option>
              </datalist>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="searchAnoFab"
              />
              <label>Ano Fab.</label>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="searchAnoMod"
              />
              <label>Ano Mod.</label>
            </div>
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="searchVendaFutura"
              >
                <option value="">-----</option>
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </select>
              <label>Venda Futura</label>
            </div>
          </div>
          <div class="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
            <div class="form-floating txt-form-label">
              <select class="form-select txt-form-input" v-model="searchStatus">
                <option value="">------</option>
                <option value="0">Desabilitado</option>
                <option value="1">Habilitado</option>
              </select>
              <label>Status</label>
            </div>
          </div>
          <div class="col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="pageSize"
                @change="handlePageSizeChange(pageSize)"
              >
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
              <label>Itens pág.</label>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  retrieveModelos();
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveModelos();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveModelos();
                "
              >
                <span>Pesquisar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tabelas-->
    <div class="card-container">
      <div class="card">
        <div class="d-md-none">
          <!-- Indicador de Carregamento -->
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in modelo_veiculo"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Código:</strong>
                      {{ item.codigo }}
                    </p>
                    <p class="card-table-item">
                      <strong>Edição:</strong>
                      {{ item.edicao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Cilindro:</strong>
                      {{ item.cilindro }}
                    </p>
                    <p class="card-table-item">
                      <strong>Potência:</strong>
                      {{ item.potencia }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Forçado:</strong>
                      {{ item.precoForcado }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Venda:</strong>
                      {{ currency(item.precoVenda) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Ano Fabricação:</strong>
                      {{ item.anoFabricacao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Ano Modelo:</strong>
                      {{ item.anoModelo }}
                    </p>
                    <p class="card-table-item">
                      <strong>Venda Futura:</strong>
                      {{ getVendaFut(item.vendaFutura) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Venda F&I:</strong>
                      {{ getVendaFEI(item.venda_fei) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Família:</strong>
                      {{ item.familia_veiculo.descricao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Combustível:</strong>
                      {{ item.combustivel_veiculo.descricao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Status:</strong>
                      {{ getStatus(item.status) }}
                    </p>
                    <button
                      type="button"
                      class="btn round-btn align-self-end"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_modelo(item)"
                    >
                      <i class="bi bi-pencil-square"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <!-- Indicador de Carregamento -->
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <div
              v-for="item in modelo_veiculo"
              :key="item.descricao"
              class="accordion mb-2"
            >
              <div class="accordion-item">
                <button
                  class="accordion-button collapsed card-table-txt"
                  data-bs-toggle="collapse"
                  :data-bs-target="'#row-' + item.id"
                >
                  {{ item.descricao }}
                </button>
                <div :id="'row-' + item.id" class="accordion-collapse collapse">
                  <div class="accordion-body">
                    <p class="card-table-item">
                      <strong>Código:</strong>
                      {{ item.codigo }}
                    </p>
                    <p class="card-table-item">
                      <strong>Edição:</strong>
                      {{ item.edicao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Cilindro:</strong>
                      {{ item.cilindro }}
                    </p>
                    <p class="card-table-item">
                      <strong>Potência:</strong>
                      {{ item.potencia }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Forçado:</strong>
                      {{ item.precoForcado }}
                    </p>
                    <p class="card-table-item">
                      <strong>Preço Venda:</strong>
                      {{ currency(item.precoVenda) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Ano Fabricação:</strong>
                      {{ item.anoFabricacao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Ano Modelo:</strong>
                      {{ item.anoModelo }}
                    </p>
                    <p class="card-table-item">
                      <strong>Venda Futura:</strong>
                      {{ getVendaFut(item.vendaFutura) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Venda F&I:</strong>
                      {{ getVendaFEI(item.venda_fei) }}
                    </p>
                    <p class="card-table-item">
                      <strong>Família:</strong>
                      {{ item.familia_veiculo.descricao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Combustível:</strong>
                      {{ item.combustivel_veiculo.descricao }}
                    </p>
                    <p class="card-table-item">
                      <strong>Status:</strong>
                      {{ getStatus(item.status) }}
                    </p>
                    <button
                      type="button"
                      class="btn btn-modal"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      @click="editar_modelo(item)"
                    >
                      <span>Editar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-lg-block">
          <table class="table rf_texto" v-if="!isLoading">
            <thead>
              <tr>
                <th scope="col">Código</th>
                <th scope="col">Descrição</th>
                <!-- <th scope="col">Edição</th> -->
                <!-- <th scope="col">Cilindro</th> -->
                <th scope="col">Potência</th>
                <!-- <th scope="col">Preço Forçado</th> -->
                <th scope="col">Preço Venda</th>
                <th scope="col">Ano Fab.</th>
                <th scope="col">Ano Mod.</th>
                <th scope="col">Venda Fut.</th>
                <th scope="col">Familia</th>
                <th scope="col">Comb.</th>
                <th scope="col">Status</th>
                <th scope="col">Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in modelo_veiculo"
                :key="item.descricao"
                class="table-linha"
              >
                <td>{{ item.codigo }}</td>
                <td>{{ item.descricao }}</td>
                <!-- <td>{{ item.edicao }}</td> -->
                <!-- <td>{{ item.cilindro }}</td> -->
                <td>{{ item.potencia }}</td>
                <!-- <td>{{ item.precoForcado }}</td> -->
                <td>{{ currency(item.precoVenda) }}</td>
                <td>{{ item.anoFabricacao }}</td>
                <td>{{ item.anoModelo }}</td>
                <td>{{ getVendaFut(item.vendaFutura) }}</td>
                <td>{{ item.familia_veiculo.descricao }}</td>
                <td>{{ item.combustivel_veiculo.descricao }}</td>
                <td>{{ getStatus(item.status) }}</td>

                <td>
                  <button
                    type="button"
                    class="dropdown-toggle-icon"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editar_modelo(item)"
                  >
                    <i class="bi bi-pencil-square"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else class="loading-indicator">Carregando...</div>
        </div>
        <pagination
          v-if="modelo_veiculo.length"
          :total="totalItems"
          :limit="pageSize"
          :offset="currentPage"
          :totalPages="Math.ceil(totalItems / pageSize)"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <!-- Modal para edição -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content card-container">
          <div class="modal-header">
            <i class="bi bi-pencil-square icon-text-logout"></i>
            <span class="txt-title-modal"> Editar Modelo</span>
            <button
              class="btn-close"
              type="button"
              data-bs-toggle="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body txt-body-modal">
            <div class="row g-2 p-2">
              <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_id"
                    disabled
                  />
                  <label>ID</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_codigo"
                    required
                  />
                  <label>Código</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_edicao"
                  />
                  <label>Edição</label>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_descricao"
                    required
                    autocomplete="off"
                  />
                  <label>Descrição</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_cilindro"
                  />
                  <label>Cilindro</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control"
                    v-model="edit_potencia"
                  />
                  <label>Potência</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_precoForcado"
                  />
                  <label>Preço Forçado</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_precoVenda"
                    @input="edit_precoVenda = formatarValor(edit_precoVenda)"
                  />
                  <label>Preço Venda</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_anoFabricacao"
                    required
                    autocomplete="off"
                  />
                  <label>Ano Fabricação</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    class="form-control txt-form-input"
                    v-model="edit_anoModelo"
                    required
                    autocomplete="off"
                  />
                  <label>Ano Modelo</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_vendaFutura"
                    required
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  <label>Venda Futura</label>
                </div>
              </div>
              <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div class="form-floating txt-form-label">
                <select
                  class="form-select txt-form-input"
                  v-model="edit_venda_fei"
                  required
                >
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
                <label>Venda F&I</label>
              </div>
            </div> -->
              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_status"
                    required
                  >
                    <option value="0">Desabilitado</option>
                    <option value="1">Habilitado</option>
                  </select>
                  <label>Status</label>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    list="datalistFamilia"
                    v-model="selectedOption.descricao"
                    @change="updateSelectedOption"
                    class="form-control txt-form-input"
                  />
                  <label>Família</label>

                  <datalist id="datalistFamilia">
                    <option>{{ this.edit_familia }}</option>
                    <option
                      v-for="familia in familias"
                      :value="familia.descricao"
                      :selected="selectedOption.id === familia.id"
                      :key="familia.id"
                    >
                      {{ familia.descricao }}
                    </option>
                  </datalist>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                <div class="form-floating txt-form-label">
                  <input
                    type="text"
                    list="datalistCombustivel"
                    v-model="selectedOptionCombustivel.descricao"
                    @change="updateSelectedOptionCombustivel"
                    class="form-control txt-form-input"
                  />
                  <label>Combustível</label>

                  <datalist id="datalistCombustivel">
                    <option>{{ this.edit_combustivel }}</option>
                    <option
                      v-for="comb in combustiveis"
                      :value="comb.descricao"
                      :selected="selectedOptionCombustivel.id === comb.id"
                      :key="comb.id"
                    >
                      {{ comb.descricao }}
                    </option>
                  </datalist>
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
                <div class="form-floating txt-form-label">
                  <select
                    class="form-select txt-form-input"
                    v-model="edit_tipo_empresa"
                    required
                  >
                    <option value="1">Quatro Rodas</option>
                    <option value="2">Duas Rodas</option>
                  </select>
                  <label>Tipo Empresa</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-md-none">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-x-circle" title="Cancelar"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn round-btn"
                    @click="update()"
                    data-bs-dismiss="modal"
                  >
                    <i class="bi bi-check-circle" title="Confirmar"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">
              <div class="row">
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                  >
                    Cancelar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    type="button"
                    class="btn btn-modal"
                    data-bs-dismiss="modal"
                    @click="update()"
                  >
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import axios from "axios";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";

export default {
  name: "Modelo",
  components: {
    SidebarVue,
    Navgator,
    Pagination,
    Message,
    RodapeVue
  },
  data() {
    return {
      isLoading: false,
      company_id: "",
      modelo_veiculo: [],
      familiaSelecionada: "",
      selectedOption: { id: null, descricao: "" },
      selectedOptionCombustivel: { id: null, descricao: "" },
      familias: [],
      combustiveis: [],
      valor: 0,
      msg: null,
      abrir_modal: null,

      //Campos de cadastro
      codigo: "",
      descricao: "",
      edicao: "",
      cilindro: 0,
      potencia: 0,
      precoForcado: 0,
      precoVenda: 0,
      custoMarcacao: 0,
      anoFabricacao: "",
      anoModelo: "",
      vendaFutura: "",
      status: "",
      familiaVeiculoId: "",
      editfamiliaVeiculoId: "",
      combustivelVeiculoId: "",
      combustivelSelecionado: "",
      tipo_empresa: "",
      venda_fei: 0,

      //Campos de edição
      edit_id: "",
      edit_codigo: "",
      edit_edicao: "",
      edit_cilindro: "",
      edit_potencia: "",
      edit_precoForcado: "",
      edit_precoVenda: "",
      edit_anoFabricacao: "",
      edit_anoModelo: "",
      edit_vendaFutura: "",
      edit_status: "",
      edit_familiaVeiculoId: "",
      edit_combustivelVeiculoId: "",
      edit_descricao: "",
      edit_combustivel: "",
      edit_tipo_empresa: "",
      edit_venda_fei: 0,

      edit_familia: "",

      //Filtros
      searchTitle: "",
      searchAnoFab: "",
      searchAnoMod: "",
      searchVendaFutura: "",
      searchStatus: "",
      searchFamiliaSelecionada: "",
      searchFamiliaSelecionadaId: "",
      searchCombustivelSelecionado: "",
      searchCombustivelSelecionadoId: "",

      page: 1,
      totalPages: 0,
      totalItems: 0,
      totalPagesFamilias: 0,
      totalItemsFamilias: 0,
      totalPagesComb: 0,
      totalItemsComb: 0,
      pageSizes: [5, 10, 15, 35],
      pageSize: 5
    };
  },
  watch: {
    familiaSelecionada: function (novaFamilia) {
      const familia = this.familias.find((m) => m.descricao === novaFamilia);
      this.familiaVeiculoId = familia ? familia.id : null;
    },
    searchFamiliaSelecionada: function (novaFamilia) {
      const familia = this.familias.find((m) => m.descricao === novaFamilia);
      this.searchFamiliaSelecionadaId = familia ? familia.id : null;
    },
    combustivelSelecionado: function (novoCombustivel) {
      const combustivel = this.combustiveis.find(
        (m) => m.descricao === novoCombustivel
      );
      this.combustivelVeiculoId = combustivel ? combustivel.id : null;
      this.searchCombustivelSelecionadoId = combustivel ? combustivel.id : null;
    },
    searchCombustivelSelecionado: function (novoCombustivel) {
      const combustivel = this.combustiveis.find(
        (m) => m.descricao === novoCombustivel
      );
      this.searchCombustivelSelecionadoId = combustivel ? combustivel.id : null;
    }
  },
  mounted() {
    this.getToken();
    this.retrieveModelos();
    this.retrieveFamilias();
    this.retrieveCombustiveis();
  },
  methods: {
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();
      const decodedToken = jwt_decode(accessToken);

      this.company_id = decodedToken.company;
    },
    currency(number) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      }).format(number);
    },
    formatarValor(valor) {
      if (!valor) return "";
      valor = valor.toString().replace(/\D/g, "");
      valor = (valor / 100).toFixed(2).replace(".", ",");
      valor = valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return valor;
    },
    clearSelection() {
      this.selectedOption = {};
      this.selectedOptionCombustivel = {};
    },

    resetForm() {
      (this.codigo = ""),
        (this.descricao = ""),
        (this.vendaFutura = ""),
        (this.marcaVeiculoId = ""),
        (this.status = "");
    },
    getStatus(status) {
      return status === 0 ? "Desabilitado" : "Habilitado";
    },
    getVendaFut(vendaFutura) {
      return vendaFutura === 0 ? "Não" : "Sim";
    },
    getVendaFEI(venda_fei) {
      return venda_fei === 0 ? "Não" : "Sim";
    },

    async onSubmit() {
      try {
        await fetch(`${process.env.VUE_APP_API_URL}modelo`, {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            codigo: this.codigo,
            descricao: this.descricao,
            edicao: this.edicao,
            cilindro: this.cilindro,
            potencia: this.potencia,
            precoForcado: this.precoForcado,
            precoVenda: this.precoVenda,
            custoMarcacao: this.custoMarcacao,
            vendaFutura: this.vendaFutura,
            venda_fei: this.venda_fei,
            anoFabricacao: this.anoFabricacao,
            anoModelo: this.anoModelo,
            status: this.status,
            familiaVeiculoId: this.familiaVeiculoId,
            combustivelVeiculoId: this.combustivelVeiculoId,
            tipo_empresa: this.tipo_empresa
          })
        })
          .then((data) => {
            if (!data.ok) {
              throw Error(data.status);
            }
            return data.json();
          })
          .then((resposta) => {
            if (resposta.StatusOk == 200) {
              this.abrir_modal = true;
              this.msg = resposta.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
              window.location.reload();
            }
            if (resposta.StatusOk == 204) {
              this.abrir_modal = true;
              this.msg = resposta.message;
              setTimeout(() => (this.abrir_modal = false), 4000);
            }
          })
          .catch((error) => {
            if (error.response.status == 400) {
              this.abrir_modal = true;
              this.msg = error.response.data.message;
            }
          });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },
    //Buscar dados no banco de dados
    getRequestParams(
      searchTitle,
      page,
      pageSize,
      searchAnoFab,
      searchAnoMod,
      searchVendaFutura,
      searchStatus,
      searchFamiliaSelecionadaId,
      searchCombustivelSelecionadoId,
      company_id
    ) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (searchAnoFab) {
        params["anoFab"] = searchAnoFab;
      }
      if (searchAnoMod) {
        params["anoMod"] = searchAnoMod;
      }
      if (searchVendaFutura) {
        params["vendaFutura"] = searchVendaFutura;
      }
      if (searchStatus) {
        params["status"] = searchStatus;
      }
      if (searchFamiliaSelecionadaId) {
        params["familia"] = searchFamiliaSelecionadaId;
      }
      if (searchCombustivelSelecionadoId) {
        params["combustivel"] = searchCombustivelSelecionadoId;
      }
      if (company_id) {
        params["company_id"] = company_id;
      }
      return params;
    },
    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveModelos(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveModelos();
    },

    getRequestParamsFamilias(searchTitle, page, pageSize) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },
    async handlePageChangeFamilias(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveFamilias(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChangeFamilias(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveFamilias();
    },

    getRequestParamsComb(searchTitle, page, pageSize) {
      let params = {};
      if (searchTitle) {
        params["nome"] = searchTitle;
      }
      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },
    async handlePageChangeComb(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveCombustiveis(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChangeComb(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveCombustiveis();
    },

    async retrieveModelos(page = this.page) {
      try {
        const params = this.getRequestParams(
          this.searchTitle,
          page,
          this.pageSize,
          this.searchAnoFab,
          this.searchAnoMod,
          this.searchVendaFutura,
          this.searchStatus,
          this.searchFamiliaSelecionadaId,
          this.searchCombustivelSelecionadoId,
          this.company_id
        );
        const response = await userService.getModelo(params);
        const { modelo_veiculo, totalPages, totalItems } = response.data;
        this.modelo_veiculo = modelo_veiculo;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
        console.log(response.data);
        return true;
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },
    async retrieveFamilias() {
      try {
        const params = this.getRequestParamsFamilias(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService.getFamilia_at(params).then((response) => {
          const { familia_veiculo, totalPages, totalItems } = response.data;
          this.familias = familia_veiculo;
          this.totalPagesFamilias = totalPages;
          this.totalItemsFamilias = totalItems;
          console.log(response.data);
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    async retrieveCombustiveis() {
      try {
        const params = this.getRequestParamsComb(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        userService.getCombustiveis(params).then((response) => {
          const { combustivel, totalPages, totalItems } = response.data;
          this.combustiveis = combustivel.filter((comb) => comb.status === 1);
          this.totalPagesComb = totalPages;
          this.totalItemsComb = totalItems;
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    },

    async editar_modelo(item) {
      console.log("Dados para edição");
      console.log(item);
      (this.edit_id = item.id),
        (this.edit_codigo = item.codigo),
        (this.edit_descricao = item.descricao),
        (this.edit_edicao = item.edicao),
        (this.edit_cilindro = item.cilindro),
        (this.edit_potencia = item.potencia),
        (this.edit_precoForcado = item.precoForcado),
        (this.edit_precoVenda = this.currency(item.precoVenda)),
        (this.edit_anoFabricacao = item.anoFabricacao),
        (this.edit_anoModelo = item.anoModelo),
        (this.edit_vendaFutura = item.vendaFutura),
        (this.edit_venda_fei = item.venda_fei),
        (this.selectedOption.descricao = item.familia_veiculo.descricao),
        (this.edit_familiaVeiculoId = item.familiaVeiculoId),
        (this.edit_combustivelVeiculoId = item.combustivelVeiculoId),
        (this.selectedOptionCombustivel.descricao =
          item.combustivel_veiculo.descricao);
      this.edit_status = item.status;
      this.edit_tipo_empresa = item.tipo_empresa;
      this.updateSelectedOption();
      this.updateSelectedOptionCombustivel();
    },
    updateSelectedOption() {
      const selectedOption = this.familias.find(
        (option) => option.descricao === this.selectedOption.descricao
      );
      if (selectedOption) {
        this.selectedOption = {
          id: selectedOption.id,
          descricao: selectedOption.descricao
        };
      } else {
        this.selectedOption = { id: this.edit_familiaVeiculoId, descricao: "" };
      }
    },
    updateSelectedOptionCombustivel() {
      const selectedOption = this.combustiveis.find(
        (option) =>
          option.descricao === this.selectedOptionCombustivel.descricao
      );
      if (selectedOption) {
        this.selectedOptionCombustivel = {
          id: selectedOption.id,
          descricao: selectedOption.descricao
        };
      } else {
        this.selectedOptionCombustivel = {
          id: this.edit_combustivelVeiculoId,
          descricao: ""
        };
      }
    },
    async update() {
      const token = this.$store.state.auth.user.accessToken;
      const headers = {
        "x-access-token": token
      };
      const dados = {
        id: this.edit_id,
        codigo: this.edit_codigo,
        descricao: this.edit_descricao,
        edicao: this.edit_edicao,
        cilindro: this.edit_cilindro,
        potencia: this.edit_potencia,
        precoForcado: this.edit_precoForcado,
        precoVenda: this.edit_precoVenda,
        custoMarcacao: this.custoMarcacao,
        vendaFutura: this.edit_vendaFutura,
        venda_fei: this.edit_venda_fei,
        anoFabricacao: this.edit_anoFabricacao,
        anoModelo: this.edit_anoModelo,
        status: this.edit_status,
        familiaVeiculoId: this.selectedOption.id,
        combustivelVeiculoId: this.selectedOptionCombustivel.id,
        tipo_empresa: this.edit_tipo_empresa
      };
      console.log(dados);

      const response = await axios.put(
        `${process.env.VUE_APP_API_URL}modelo/${this.edit_id}`,
        dados,
        { headers }
      );
      console.log(response.data.StatusOk);
      if (response.data.StatusOk == 200) {
        this.abrir_modal = true;
        this.msg = response.data.message;
        setTimeout(() => (this.abrir_modal = false), 4000);
        // this.resetForm();
        // this.retrieveFamilias();
        window.location.reload();
      }
      return console.log(response.data);
    }
  }
};
</script>
